import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";




export class Link {

  constructor(private $log: Logger, private $util: Utils) {
    this.handleBrowserBackLinks();
  }


  private handleBrowserBackLinks() {
    const browserBackLinks = document.querySelectorAll<HTMLLinkElement>('a.js-browser-back');

    browserBackLinks?.forEach(browserBackLink => {
      browserBackLink?.addEventListener('click', (event) => {
        if (window.history.length <= 1) {
          return;
        }

        event.preventDefault();
        history.back();
      });
    });
  }
}
